import Stardog from 'stardog';

/**
 * Check response for session timeout message.
 */
export const handleSessionTimeoutRedirectResponse = (
  response: Stardog.HTTP.Body
): boolean => {
  const isSessionTimeoutRedirectResponse = Boolean(
    response.body && response.body.Expired && response.body.Location
  );

  if (isSessionTimeoutRedirectResponse) {
    sessionTimeoutRedirect(window, response.body.Location);
  }

  return isSessionTimeoutRedirectResponse;
};

/**
 * Redirects the user to a login screen.
 * This is used by cloud and portal to re-authenticate users.
 */
export const sessionTimeoutRedirect = (window: Window, location: string) => {
  try {
    const parsedLocation = new URL(location);
    console.warn('Redirecting to session timeout location', location);
    window.location.assign(parsedLocation.toString());
  } catch (err) {
    console.error('Invalid URL for redirection, ignoring');
  }
};
